var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 150,
    viewBox: "0 0 155 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.26416 0H154.767V150H0.26416V0Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8888 125.351L52.7119 118.404C54.9932 122.33 57.0681 125.653 62.0454 125.653C66.8163 125.653 69.8249 123.841 69.8249 116.793V68.8647H84.344V116.992C84.344 131.592 75.5288 138.238 62.6677 138.238C51.0528 138.238 44.3108 132.398 40.8882 125.35",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2303 123.84L104.052 117.195C107.165 122.129 111.209 125.754 118.365 125.754C124.381 125.754 128.217 122.834 128.217 118.806C128.217 113.973 124.276 112.261 117.639 109.443L114.01 107.931C103.534 103.603 96.586 98.1652 96.586 86.6867C96.586 76.1141 104.883 68.0586 117.847 68.0586C127.077 68.0586 133.715 71.1805 138.485 79.3361L127.18 86.385C124.69 82.0555 121.995 80.3439 117.846 80.3439C113.594 80.3439 110.897 82.9619 110.897 86.385C110.897 90.6137 113.594 92.3264 119.816 94.9443L123.446 96.4543C135.788 101.59 142.737 106.825 142.737 118.605C142.737 131.293 132.469 138.24 118.676 138.24C105.194 138.24 96.4816 131.997 92.2297 123.841",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154.503,
    height: 150,
    fill: "white",
    transform: "translate(0.26416)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.c42e81283aad0e18956c7d611b867e9c.svg";
export { ForwardRef as ReactComponent };